import gql from "graphql-tag";

const RESET_PRICES = gql`
  mutation resetPrices($userId: ID!) {
    resetPrices(userId: $userId)
  }
`;

export default RESET_PRICES;
